module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'borderless': _vm.showDetailedView
    }
  }, [(!_vm.showDetailedView) ? _c('div', {
    staticClass: "border-bottom search-box",
    class: {
      'focus-input': _vm.focussed
    }
  }, [_c('label', {
    staticClass: "field-title",
    class: {
      'on': _vm.focussed
    }
  }, [_vm._v("\n      " + _vm._s(_vm.searchLabel) + "\n    ")]), _vm._v(" "), (_vm.focussed) ? _c('span', {
    staticClass: "enter-manual-class",
    on: {
      "mousedown": function($event) {
        _vm.showDetailedView = true
      }
    }
  }, [_vm._v("\n    Click here to enter manually.\n    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "gmap_input",
    attrs: {
      "type": "text",
      "id": "billing-address",
      "name": "billingAddress",
      "placeholder": ""
    },
    on: {
      "focus": function($event) {
        _vm.focussed = true
      },
      "blur": function($event) {
        _vm.focussed = false
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showDetailedView) ? _c('div', {
    staticClass: "address show",
    class: {
      'focus-input': _vm.focussed
    }
  }, [_vm._l((_vm.fieldsWithFullWidth), function(field) {
    return [(field.type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field.name]),
        expression: "values[field.name]"
      }],
      attrs: {
        "config": field
      },
      domProps: {
        "value": (_vm.values[field.name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field.name;
          if (!Array.isArray($$exp)) {
            _vm.values[field.name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e()]
  }), _vm._v(" "), _vm._l((_vm.doubleFields), function(field) {
    return [(field.length == 2) ? _c('div', {
      staticClass: "clearfix double-address-fields"
    }, [(field[0].type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[0].name]),
        expression: "values[field[0].name]"
      }],
      attrs: {
        "customclass": 'left',
        "config": field[0]
      },
      domProps: {
        "value": (_vm.values[field[0].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[0].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[0].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (field[0].type === 'select') ? _c('select-box', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[0].name]),
        expression: "values[field[0].name]"
      }],
      attrs: {
        "customclass": 'left',
        "config": field[0]
      },
      domProps: {
        "value": (_vm.values[field[0].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[0].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[0].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (field[1].type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[1].name]),
        expression: "values[field[1].name]"
      }],
      attrs: {
        "customclass": 'right',
        "config": field[1]
      },
      domProps: {
        "value": (_vm.values[field[1].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[1].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[1].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (field[1].type === 'select') ? _c('select-box', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[1].name]),
        expression: "values[field[1].name]"
      }],
      attrs: {
        "customclass": 'right',
        "config": field[1]
      },
      domProps: {
        "value": (_vm.values[field[1].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[1].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[1].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (field.length == 1) ? [(field[0].type === 'text') ? _c('text-field', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[0].name]),
        expression: "values[field[0].name]"
      }],
      attrs: {
        "config": field[0]
      },
      domProps: {
        "value": (_vm.values[field[0].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[0].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[0].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (field[0].type === 'select') ? _c('select-box', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values[field[0].name]),
        expression: "values[field[0].name]"
      }],
      attrs: {
        "config": field[0]
      },
      domProps: {
        "value": (_vm.values[field[0].name])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.values,
            $$idx = field[0].name;
          if (!Array.isArray($$exp)) {
            _vm.values[field[0].name] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }) : _vm._e()] : _vm._e()]
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19d0798e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddressComponent.vue
// module id = 72
// module chunks = 0